import { Link } from 'react-router-dom';
import { Megaphone, Pin } from 'lucide-react';
import { formatInstant } from '@hrms/ui';
import { useAuthenticatedSession } from '../../session/SessionProvider.js';
import { tsr } from '../../lib/api.js';
import {
  ANNOUNCEMENT_QUERY_KEY,
  UnreadMarker,
} from '../../features/announcements/announcementShared.js';
import { HomeCard } from './HomeCard.js';
import { ListRow } from './ListRow.js';

const SHOWN = 3;

/**
 * "Latest announcements": the first few entries of the caller's feed (ADR 0029) — pinned first,
 * then newest — with the unread marker the full page shows.
 */
export function MyAnnouncements() {
  const { permissions } = useAuthenticatedSession();
  const allowed = permissions.has('announcement:read');
  const query = tsr.announcements.listMyAnnouncements.useQuery({
    queryKey: [...ANNOUNCEMENT_QUERY_KEY, 'mine', { unreadOnly: false, limit: SHOWN }],
    queryData: { query: { limit: SHOWN, offset: 0 } },
    enabled: allowed,
  });
  const body = query.data?.status === 200 ? query.data.body : null;
  const items = body?.items ?? [];

  return (
    <HomeCard
      title="Latest Announcements"
      tag={body && body.unreadCount > 0 ? `${body.unreadCount} unread` : undefined}
      viewAll={{ to: '/engage/announcements', label: 'View all' }}
      query={allowed ? { isPending: query.isPending, isError: query.isError } : undefined}
      isEmpty={items.length === 0}
      emptyTitle="No announcements"
      emptyDescription="Company announcements will show here."
    >
      <ul className="flex flex-col gap-2">
        {items.map((a) => (
          <ListRow
            key={a.id}
            icon={a.pinned ? <Pin className="size-4" /> : <Megaphone className="size-4" />}
            primary={
              <Link
                to={`/engage/announcements/${a.id}`}
                className="flex items-center gap-1.5 hover:underline"
              >
                {a.readAt === null && <UnreadMarker />}
                <span className="truncate">{a.title}</span>
              </Link>
            }
            secondary={formatInstant(a.publishedAt)}
          />
        ))}
      </ul>
    </HomeCard>
  );
}
